import React, { useEffect, useState } from "react";

import {
  DatePicker,
  InputLabel,
  CustomerPicker,
  RadioButtonGroup,
  Picker,
} from "components";
import FiltersTemplate from "screens/components/FiltersTemplate";

import { sizes, strings } from "assets/constants";
import { filtersItems } from "assets/data";
import { useReminderTypes } from "clients/apis";
import { Platform, View } from "react-native";

export interface RemindersFiltersT {
  date?: string;
  customer?: PickerItemT;
  type?: RadioButtonItemT;
}

export default function Filters(props: {
  visible: boolean;
  hide?: () => void;
  initials: RemindersFiltersT;
  apply?: (newFilters: RemindersFiltersT) => void;
}) {
  const { data: reminderTypes } = useReminderTypes();
  const { initials, hide, apply, visible } = props;

  const [innerFilters, setInnerFilters] = useState(initials);

  useEffect(() => setInnerFilters(initials), [initials]);

  const _onApply = () => apply && apply(innerFilters);
  const _onCancel = () => {
    setInnerFilters(initials);
    hide && hide();
  };

  return (
    <FiltersTemplate
      filtersItems={filtersItems.reminders}
      innerFilters={innerFilters}
      setInnerFilters={setInnerFilters}
      visible={visible}
      _onApply={_onApply}
      _onCancel={_onCancel}
    >
      <>
        <InputLabel label={strings.customer} />
        <CustomerPicker
          value={innerFilters.customer}
          onSelect={(customer) =>
            setInnerFilters({ ...innerFilters, customer })
          }
        />

        <InputLabel
          style={{
            marginTop: Platform.OS === "web" ? sizes.space : sizes.space * 1.5,
          }}
          label={strings.type}
        />
        {reminderTypes && (
          <Picker
            data={reminderTypes?.data}
            value={innerFilters?.type?.title}
            onSelect={(type) => setInnerFilters({ ...innerFilters, type })}
            placeholder={strings.pick_customer_birthday}
            icon={{ name: "calendar" }}
          />
        )}

        <InputLabel label={strings.date} />
        <DatePicker
          value={innerFilters.date}
          onSelect={(date) => setInnerFilters({ ...innerFilters, date })}
          placeholder={strings.pick_reminder_date}
        />
      </>
    </FiltersTemplate>
  );
}
